/* @author: Augusto Monteiro */

Greenmile.Panel = Greenmile.Panel || {};

Greenmile.Panel.CardList = function (id) {

    this.panel = App.Panels[id];
    this.cardList = [];
    this.fields = [];
    this.rules = [];
    this.cardContainer = document.createElement("div");
    this.cardContainer.classList.add("CardContainer");
    this.updaterInstance = null;
    this.isToFlipCards = false;
    this.pendingCards = 0;

    this.setPanelId = function (id) {
        this.panel = App.Panels[id];
    };

    this._getCardColor = function (panelRuleId) {
        return this.panel.panel.panelRules.filter(function (rule) {
            return rule.id === panelRuleId;
        })[0];
    };

    this.executeFilter = function () {
        $('#loading_img').show();

        this.panel.firstResult = 0;
        Greenmile.Panel.Resources.getCardsByMonetCriteria({
            id: id,
            data: this.panel.header.getFilterWithPagination(),
            onSuccess: function (response) {
                this.cardContainer.innerHTML = '';
                this.cardList = [];
                const flip = this.cardContainer.parentElement.querySelector('.PanelHeader .QuickColorsFilter .QuickColorsFilterItem.active').getAttribute('flip');
                this.renderCards(response, flip == "true");

                $('#loading_img').hide();

            }.bind(this)
        });
    };

    this.sortPanelCardFields = function (fields) {
        return fields.sort((a,b) => a.fieldPosition - b.fieldPosition)
    };

    this.createCardsFragment = function (cards, isToFlip) {

        var cardInstance   = null
            , cardFragment = document.createDocumentFragment();

        cards.forEach(function (card) {

            cardInstance = new Greenmile.Panel.Card();

            cardFragment.appendChild(cardInstance.create(this.sortPanelCardFields(this.panel.panel.panelCardFields), card.model, this._getCardColor(card.panelRule.id), isToFlip));
            this.cardList.push(cardInstance);
            cardInstance = null;

        }, this);

        return cardFragment;
    };

    this.setTotals = function (response) {
        this.panel.totals = response.totals;
    };

    this.updateTotals = function () {
        this.panel.header.updateTotals();
    };

    this.renderNoResults = () => {
        let noResultContainer = this.cardContainer.querySelector(".noResultContainer");
        if (!noResultContainer) {
            noResultContainer = document.createElement("div");
            noResultContainer.classList.add("noResultContainer");
            noResultContainer.innerHTML = Monet.I18n.getResourcesByKey('panel.noCardsToShow');
    
            this.cardContainer.appendChild(noResultContainer);
        }
    }

    this.hideNoResults = () => {
        const noResultContainer = this.cardContainer.querySelector(".noResultContainer");
        noResultContainer && this.cardContainer.removeChild(noResultContainer);
    }

    this.renderCardsFirst = function (response) {
        const cards = response.panelCards;
        const isToFlip = this.isToFlipCards;
        this.cardContainer.innerHTML = '';
        this.setTotals(response);
        this.panel.header.render();
        this.updateTotals();
        if (cards.length === 0 && response.pendingCards === 0) {
            this.renderNoResults();
        } else {
            this.panel.firstResult = cards.length;
            this.cardContainer.appendChild(this.createCardsFragment(cards, isToFlip));
        }
    }.bind(this);

    this.setIsToFlipCards = (sideCardToShow) => {
        if(sideCardToShow === 'BACK')
            this.isToFlipCards = true;
    };

    this.renderCards = function (response, isToFlip) {
        var cards = response.panelCards;
        const isToFlipCards = isToFlip ?? this.isToFlipCards;
        const panelHaveCardlists = this.panel.cardList.cardList.length;
        const hasNoResults = (
            this.panel.firstResult === 0 
            && cards.length === 0 
            && response.pendingCards === 0
        );

        this.setTotals(response);
        this.updateTotals();

        if(panelHaveCardlists && hasNoResults) {
            this.hideNoResults();
            return;
        }
        
        if (hasNoResults) {
            this.renderNoResults();
        } else {
            this.hideNoResults();
            this.panel.firstResult += cards.length;
            this.cardContainer.appendChild(this.createCardsFragment(cards, isToFlipCards));
        }
    };

    this.paginate = function () {

        Greenmile.Panel.Resources.getCardsByMonetCriteria({
            id: id,
            data: this.panel.header.getFilterWithPagination(),
            onSuccess: function (response) {
                this.renderCards(response);
            }.bind(this)
        });

    };

    this.updateCards = function (cards) {
        const isToFlip = this.isToFlipCards;

        if (!cards.length) {
            this.renderNoResults();
            return;
        }

        this.hideNoResults();

        this.cardContainer.innerText = "";

        if (cards.length) {
            this.panel.firstResult = cards.length;
            this.cardContainer.appendChild(this.createCardsFragment(cards, isToFlip));
        }

    };

    this.removePanelFromUpdater = function () {
        this.updaterInstance.stop();
        this.updaterInstance = null;
    }

    this.render = function () {
        this.updaterInstance = new Greenmile.Panel.Updater(id);

        Greenmile.Panel.Resources.getCardsByMonetCriteria({
            id: id,
            data: this.panel.header.getFilterWithPagination(),
            onSuccess: (response) => {
                if (response.pendingCards > 0) {
                    this.panel.firstResult += response.pendingCards; 
                    this.updaterInstance.setUpdateInterval(5000); // 5 secs
                }
                this.updaterInstance.start();
                this.renderCardsFirst(response);
            },
            onError: () => {
                this.updaterInstance.setUpdateInterval(5000);
                this.updaterInstance.start();
            }
        });

        return this;
    };
};
